import { createRef } from "react";
import create from "zustand";

const useStore = create((set) => ({
  renderer: "",
  setRenderer: (value) => set((state) => ({ renderer: value })),
  scene: "",
  setScene: (value) => set((state) => ({ renderer: value })),
  camera: "",
  setCamera: (value) => set((state) => ({ camera: value })),
  //current layer/material
  currentMaterial: 0,
  setCurrentMaterial: (value) => set((state) => ({ currentMaterial: value })),
  materials: ["assets/dragon.png"],
  setMaterials: (value) => set((state) => ({ materials: value })),
  color: '#0000',
  setColor: (value) => set((state) => ({ color: value })),
  models: [
    "assets/LeePerrySmith/LeePerrySmith.glb",
    "assets/models/femaletorso_v2.obj",
    "assets/models/maletorso_V1.obj",
    "assets/models/woman.glb",
    "assets/models/rightarm_V3.obj",
  ],
  setModels: (value) => set((state) => ({ models: value })),
  materialScale: 0.6,
  setMaterialScale: (value) => set((state) => ({ materialScale: value })),
  position: [0, 0, 0],
  oldPosition: [0, 0, 0],
  setOldPosition: (value) => set((state) => ({ oldPosition: value })),
  setPosition: (value) => set((state) => ({ position: value })),
  rotation: [0, 0, 0],
  oldRotation: [0, 0, 0],
  setOldRotation: (value) => set((state) => ({ oldRotation: value })),
  setRotation: (value) => set((state) => ({ rotation: value })),
}));

export default useStore;
